/**
 * @fileoverview GET handler for the "/apps/:app_group_id/charts/revenue_previous_window" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { appsAppGroupIdChartsRevenuePreviousWindow } from "./constants";
import type { AppsAppGroupIdChartsRevenuePreviousWindowResult } from "./types";

export const getAppsAppGroupIdChartsRevenuePreviousWindow = reactQueryFetcherAdapter(
  appsAppGroupIdChartsRevenuePreviousWindow,
  (
    signal: AbortSignal,
    appGroupId: string,
    appIds: string[],
    startDate: number,
    endDate: number
  ): Promise<AppsAppGroupIdChartsRevenuePreviousWindowResult> => {
    return fetch(
      `/apps/${appGroupId}/charts/revenue_previous_window`,
      "GET",
      { app_ids: appIds, start_date: startDate, end_date: endDate },
      { signal }
    );
  }
);
